<section>
  <app-header></app-header>
  <div class="content">
    <app-menu *ngIf="userService.user" [rulesExportFeature]="[userService.rulesExportFeature, userService.sendAndFileExportFeature]"></app-menu>
    <router-outlet></router-outlet>
  </div>
</section>
